import { render, staticRenderFns } from "./PlannerAssignClass.vue?vue&type=template&id=52ef29fc&scoped=true"
import script from "./PlannerAssignClass.vue?vue&type=script&lang=js"
export * from "./PlannerAssignClass.vue?vue&type=script&lang=js"
import style0 from "./PlannerAssignClass.vue?vue&type=style&index=0&id=52ef29fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ef29fc",
  null
  
)

export default component.exports